// extracted by mini-css-extract-plugin
export var select = "_r4-0";